import { ReactNode } from 'react';

import { Car, CarDocType } from '@/modules/car/model';
import { IDriverBrief } from '@/modules/driver/model';
import { DriverDocType } from '@/modules/driver/model/driver-doc-type';
import { IPartner } from '@/modules/partner/model';
import { PartnerDocType } from '@/modules/partner/model/partner-doc-type';
import { TestDefinition } from '@/modules/partner/model/test-definition';
import { IDocDefinition } from '@/shared/models/doc-definition';
import { createEnum } from '@/shared/utils/createEnum';

type TAction = (params?: TActionParams) => void;

type TActionParams = Record<string, string>;

type TCardItemIntent = 'danger' | 'info' | 'success';

type TCardStatus = 'todo' | 'rejected' | 'review' | 'done';

interface ICard {
  action?: TAction;
  actionExternalLink?: string;
  actionTitle?: string;
  actionTracker?: () => void;
  cardStatus: TCardStatus;
  desc: ReactNode;
  id: string;
  isBlocked?: boolean;
  items?: ICardItem[];
  title: string;
  order?: number;
  isHiddenIfPartnerIsActive?: boolean;
  isExcludedFromProgress?: boolean;
}

const EnumCardItemStatus = createEnum(
  'addDocument',
  'approved',
  'waitingForApproval',
  'documentsError',
  'documentsExpired',
  'inReview',
);

type TEnumCardItemStatus = keyof typeof EnumCardItemStatus;

interface ICardItem {
  action?: () => void;
  internalLink?: string;
  status: TEnumCardItemStatus;
  tipIntent: TCardItemIntent;
  tipText?: string;
  title: string;
}

interface ICardContext {
  drivers: IDriverBrief[];
  driverUploadDefinitions: IDocDefinition<DriverDocType>[];
  myDriver: IDriverBrief | undefined;
  cars: Car[];
  carUploadDefinitions: IDocDefinition<CarDocType>[];
  partner: IPartner;
  partnerUploadDefinitions: IDocDefinition<PartnerDocType>[];
  allTestDefinitions: TestDefinition[];
  currentCar?: Car;
}

export { EnumCardItemStatus };

export type {
  TCardStatus,
  ICard,
  TAction,
  ICardItem,
  TEnumCardItemStatus,
  ICardContext,
  TCardItemIntent,
};
